// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"6383cb82","747":"a7e77955","888":"ac3b1c97"}[chunkId] + ".chunk.js";
};